import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { Loader2 } from 'lucide-react';

/**
 * Handles /add/:handle route — auto-sends a friend request and redirects to Friends tab.
 * Used when someone scans a QR code that encodes https://rostandfound.app/add/{handle}.
 */
export function AddFriendRedirect() {
  const { handle } = useParams<{ handle: string }>();
  const { sendFriendRequest } = useApp();
  const navigate = useNavigate();
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current || !handle) return;
    sent.current = true;

    const cleanHandle = handle.replace(/^@/, '');
    sendFriendRequest(cleanHandle).then(() => {
      navigate('/friends', { replace: true });
    });
  }, [handle, sendFriendRequest, navigate]);

  return (
    <div className="min-h-dvh bg-slate-900 flex flex-col items-center justify-center gap-3">
      <Loader2 size={24} className="text-accent animate-spin" />
      <p className="text-sm text-slate-400">Adding @{handle?.replace(/^@/, '')}...</p>
    </div>
  );
}
